import React, {useState} from 'react';
import { AlertDialog, AlertDialogButton } from 'react-onsenui';
import PropTypes from 'prop-types';
import ConfirmModal from '../confirm/ConfirmModal';

const EndDeclarationModal = props => {
    const [showEnd, setShowEnd] = useState(false);
    const [showProlongation, setShowProlongation] = useState(false);
    const [onProgress, setOnProgress] = useState(false);

    return (
        <AlertDialog isOpen={props.show} onCancel={props.onCancel} modifier='rowfooter'>
            <div className="alert-dialog-title" style={{textAlign: 'center', marginBottom: '10px'}}>
                <h6 style={{marginBottom: 0, color: '#004586', fontWeight: '700', fontFamily: 'fff-equipe'}}>Coup de sifflet final ?</h6>
            </div>
            <div className="alert-dialog-content" style={{fontSize: '14px', textAlign: 'center', marginTop: 0, color: '#004586', fontFamily: 'fff-equipe'}}>
                En cliquant sur "fin du match" tu vas terminer ton live et notifier tes spectateurs de cette action.
            </div>
            <div className="alert-dialog-footer">
                <AlertDialogButton onClick={() => setShowEnd(true)}>
                    <span style={{fontWeight: '700', textAlign: 'center', color: '#004586', fontFamily: 'fff-equipe'}}>Fin du match</span>
                </AlertDialogButton>
            </div>
            <div className="alert-dialog-footer">
                <AlertDialogButton onClick={() => setShowProlongation(true)}>
                    <span style={{fontWeight: '700', textAlign: 'center', color: '#004586', fontFamily: 'fff-equipe'}}>{props.overtimeText}</span>
                </AlertDialogButton>
            </div>
            <div className="alert-dialog-footer">
                <AlertDialogButton onClick={props.onCancel}>
                    <span style={{fontWeight: '700', textAlign: 'center', color: '#004586', fontFamily: 'fff-equipe'}}>Annuler</span>
                </AlertDialogButton>
            </div>
            <ConfirmModal 
                show={showEnd}
                disabled={onProgress}
                title='Coup de sifflet final ?'
                content='En cliqaunt sur "OK" tu vas terminer ton live et notifier tes spectateurs de la fin du match.'
                onCancel={() => setShowEnd(false)}
                onOk={() => {
                    setOnProgress(true);
                    props.endLive().then(() => setTimeout(() => setOnProgress(false), 1000));
                    setShowEnd(false);
                    props.onCancel();
                }}
            />
            <ConfirmModal 
                show={showProlongation}
                disabled={onProgress}
                title='Coup de sifflet final ?'
                content={props.overtimeContent}
                onCancel={() => setShowProlongation(false)}
                onOk={() => {
                    setOnProgress(true);
                    props.endRegularTime().then(() => setTimeout(() => setOnProgress(false), 1000));
                    setShowProlongation(false);
                    props.onCancel();
                }}
            />
        </AlertDialog>
    )
}

EndDeclarationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    endLive: PropTypes.func.isRequired,
    endRegularTime: PropTypes.func.isRequired,
    overtimeText: PropTypes.string,
    overtimeContent: PropTypes.string
}

export default EndDeclarationModal;